import Container from './JobSidebar-container';
import ReduxContainer from './JobSidebar-reduxContainer';

import JobDetails from '../JobDetails';

const ViewComponent = () => (
  <Container>
    {({ ...props }) => (
      <div className="w-full mt-14">
        <JobDetails {...props} />
      </div>
    )}
  </Container>
);

ViewComponent.displayName = 'JobSidebar-view';

const ReduxViewComponent = () => (
  <ReduxContainer>
    {({ ...props }) => (
      <div className="w-full mt-14">
        <JobDetails {...props} />
      </div>
    )}
  </ReduxContainer>
);

ReduxViewComponent.displayName = 'JobSidebar-view';

export { ReduxViewComponent };

export default ViewComponent;
